import React from 'react';

import OnBoardingModule from './routes/ModuleRoutes';

// eslint-disable-next-line react/display-name
export default () => {
  return (
    <OnBoardingModule/>
  );
};
